import { Component, OnInit} from '@angular/core';
import { NapiService} from 'src/app/services/napi.service';
import { UserLearnerStatistic, UserLearnerStatisticInterface } from '../models/learner-statistic.model';
import { UserStatisticSummaryInterface, AvgUserStatistic } from '../models/avg-learners-statistic.model';
import { DelegateSimpleModel } from '../../team/models/delegate.model';
import { CardConfig, TableConfig } from '../models/ui-config.models';
import { EMPTY_DETAILS, LEARNER_CARDS, LEARNER_TABLE_COLUMNS } from './calls-dashboard.constant';
import { AiScenario, UserAiStatistics } from '../models/top-level-statistic.model';
import { ScorecardSectionProcessor, SectionDisplayData } from '../models/scorecard-processor.model';
import { AllScorecardInfo, ScorecardSection } from '../models/ai-scorecard-statistic.model';
import { TABS_LEARNER } from '../constants/data-model.const';
import { NavService } from 'src/app/services/nav.service';
import {UserService} from '../../../services/user.service';
import { MyDevelopmentService } from '../services/my-development.service';

@Component({
  selector: 'app-calls-dashboard-page',
  templateUrl: './calls-dashboard.page.html',
  styleUrls: ['./calls-dashboard.page.scss'],
})

export class CallsDashboardPage implements OnInit {
  public tabs = TABS_LEARNER;
  public selectedTab = 'development';
  public allCallsList: any = null;
  public callsList: any = null;
  public showUserDetails = false;
  public data = null;

  protected selectedScenario: UserLearnerStatisticInterface | null = null;

  protected tableColumns: TableConfig[] = LEARNER_TABLE_COLUMNS;
  protected cards: CardConfig[] = LEARNER_CARDS;

  protected learnersStatistic: UserLearnerStatisticInterface[];
  protected avgStatistics: UserStatisticSummaryInterface | any;
  protected managers: DelegateSimpleModel[];
  protected aiScenarious: AiScenario[];
  protected statistics: UserAiStatistics;

  protected allStats: AllScorecardInfo;
  protected sectionStats: SectionDisplayData[];

  constructor(
    private myDevelopmentService: MyDevelopmentService,
  ) {}

  async ngOnInit(): Promise<void> {
    const aiScenarios = await this.myDevelopmentService.getAiScenariosFiltered();
    const statistics = await this.myDevelopmentService.getTopLevelStat();

    this.aiScenarious = aiScenarios;
    this.statistics = statistics;

    console.log('AI Scenarios:', this.aiScenarious);
    console.log('Statistics:', this.statistics);

    this.learnersStatistic = this.myDevelopmentService.getLearnerStats(this.aiScenarious, this.statistics);
    this.avgStatistics = this.myDevelopmentService.getAvgStatistics(this.learnersStatistic);

    this.allCallsList = await this.myDevelopmentService.getAllCompletedCalls();
  }

  public selectTab(tab: string) {
    const allowedTabs = (tab === 'scorecard' || tab === 'heatmap');

    if ( allowedTabs&& !this.selectedScenario) {
      return;
    }

    this.selectedTab = tab;
    if (tab === 'development') {
      this.selectedScenario = null;
      this.avgStatistics = new AvgUserStatistic(this.learnersStatistic);
      this.showUserDetails = false;
      return;
   }

    this.getStat();
  }

  protected async viewRecord(id: string): Promise<void> {
    this.data = await this.myDevelopmentService.getCallDetails(id);
    this.showUserDetails = true;
  }

  public handleBack() {
    this.showUserDetails = false;
  }

  protected selectScenario(scenario: UserLearnerStatisticInterface) {
    this.selectedScenario = scenario;
    this.selectTab('scorecard');
  }

  private async getStat(): Promise<void> {
    this.avgStatistics = this.myDevelopmentService.getAvgStatistics([this.selectedScenario]);

    this.callsList = this.allCallsList.filter(
      c => c.agentFirstName === this.selectedScenario.aiAgent.agentFirstName
    );

    console.log('All Calls:', this.allCallsList);
    console.log('Selected Calls:', this.callsList);
    console.log('Selected Scenario:', this.selectedScenario);


    const result = await this.myDevelopmentService.getDashboardData(this.selectedScenario.scenarioId);

    this.allStats = result.allStats;
    this.sectionStats = result.sectionStats;
  }

}
